import { combineReducers } from 'redux'
import notifier from './reducers/notifier'

export default combineReducers({
  notifier,
})
